<template lang="pug">
.StatisticWorkersPanel(v-if="estadisticas")
  div(v-show="chartData && chartData.length")
    GChart.BarChart(
      type="BarChart"
      :data="chartData"
      :options="chartOptions"
    )
  div(v-show="!chartData || !chartData.length")
    md-progress-spinner(md-mode="indeterminate")
</template>

<script>
import { GChart } from 'vue-google-charts'
import { grayColor } from '@/theme.js'
import colorPropertyMixin from '@/mixins/color-property.js'

export default {
  name: 'StatisticWorkersPanel',
  mixins: [colorPropertyMixin],
  components: {
    GChart
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    estadisticas: Object
  },
  mounted () {
    this.updateData()
  },
  data () {
    return {
      chartData: [],
      chartOptions: {
        height: 100,
        bars: 'horizontal',
        bar: { groupWidth: '50%' },
        chartArea: { width: '40%', left: '0', top: '1', bottom: '1' },
        legend: { position: 'none' },
        annotations: {
          textStyle: {
            fontName: 'Times-Roman',
            fontSize: 18,
            color: grayColor
          }
        },
        axes: {
          y: {
            0: { side: 'right' }
          }
        },
        hAxis: {
          textStyle: {
            color: 'white',
            fontSize: 1
          }
        },
        vAxis: {
          textStyle: {
            fontSize: 18
          }
        },
        colors: [ grayColor ]
      }
    }
  },
  methods: {
    updateData () {
      setTimeout(_ => {
        this.chartData = [
          [ '', '', { role: 'annotation' } ],
          [ '', this.formatNumber(this.estadisticas.dependiente), `${this.format(this.estadisticas.dependiente)}% Dependiente` ],
          [ '', this.formatNumber(this.estadisticas.independiente), `${this.format(this.estadisticas.independiente)}% Independiente` ],
          [ '', this.formatNumber(this.estadisticas.noInformado), `${this.format(this.estadisticas.noInformado)}% No informado` ]
        ]
      }, 1000)
    },
    format (value) {
      return value > 0 ? value : '-'
    },
    formatNumber (value) {
      return value < 0 ? 0 : value
    }
  },
  watch: {
    estadisticas () {
      this.updateData()
    }
  }
}
</script>

<style scoped lang="stylus">
.BarChart >>>
  svg
    g
      g
        g
          rect[width="1"][stroke="none"][stroke-width="0"][fill="#cccccc"],
          rect[width="1"][stroke="none"][stroke-width="0"][fill="#333333"]
            display: none
        g
          text[text-anchor="middle"][stroke="none"][stroke-width="0"],
          text[text-anchor="end"][stroke="none"][stroke-width="0"][transform]
            display: none
</style>
